"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortBy = void 0;
const lodash_1 = require("lodash");
/**
 * 配列をアイテムから算出されるDateで並べ替える
 * @param items 配列
 * @param func Tを返す関数(Tは比較可能な型)
 * @param direction 並べる方向
 * @returns
 */
const sortBy = (items, func, direction) => {
    const sortByAsc = (0, lodash_1.sortBy)(items, (i) => func(i));
    return direction === 'asc' ? sortByAsc : (0, lodash_1.reverse)(sortByAsc);
};
exports.sortBy = sortBy;
//# sourceMappingURL=sortBy.js.map